import { render, staticRenderFns } from "./UserSelectInput.vue?vue&type=template&id=4fd48f3b&"
import script from "./UserSelectInput.vue?vue&type=script&lang=js&"
export * from "./UserSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports